import { generateHTML, generateCSS, generateJS } from "lib/CodeGenerator";
import { useContext, useEffect, useRef, useState } from "react";
import { TreeContext } from "pages/Editor";
import { CodeEditor } from "../Preview/components/CodeEditor";
import Tabs, { Tab } from "lib/Window/Tabs";
// TODO: fix shared css
import "./code.css";

function HTMLTab() {
  const { tree } = useContext(TreeContext);
  const editor = useRef();
  const html = generateHTML(tree);
  return (
    <div className="pw">
      <CodeEditor ref={editor} mode="htmlmixed" value={html} readOnly />
    </div>
  );
}

function CSSTab() {
  const { tree } = useContext(TreeContext);
  const editor = useRef();
  const css = generateCSS(tree);
  return (
    <div className="pw">
      <CodeEditor ref={editor} mode="css" value={css} readOnly />
    </div>
  );
}

function JSTab() {
  const { tree } = useContext(TreeContext);
  const [code, setCode] = useState("");
  const editor = useRef();
  useEffect(() => {
    const js = generateJS(tree);
    setCode(js);
  }, [tree]);
  return (
    <div className="pw">
      <CodeEditor ref={editor} value={code} readOnly />
    </div>
  );
}

/**
 * lazy because the tabs contain codemirror editor
 * which doesn't load well when hidden
 */
export default function Code() {
  // issue #5
  // return <Tabs defaultTab={2}>
  return (
    <Tabs>
      <Tab title="HTML" lazy>
        <HTMLTab />
      </Tab>
      <Tab title="CSS" lazy>
        <CSSTab />
      </Tab>
      <Tab title="JS" lazy>
        <JSTab />
      </Tab>
    </Tabs>
  );
}
